import React from 'react';

import { SignIn } from '../../../modules/SignIn/components/SignIn';
export function SignInPage() {
	return <SignIn />;
}
